import React from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';

import { TextPage } from 'legacyComponents/pages/textPage';

import Header from 'apps/components/header/header';

import PrivacyPolicy from 'apps/home/privacy/privacy.md';
import fetchTextDocument from 'utils/fetchTextDocument';

@observer
export class Privacy extends React.Component {
  @observable content = '';

  componentDidMount() {
    fetchTextDocument(PrivacyPolicy).then(content => {
      this.content = content;
    });
  }

  render() {
    const __html = this.content;
    return (
      <>
        <Header />
        <TextPage title='Privacy Policy'>
          <div dangerouslySetInnerHTML={{ __html }} />
        </TextPage>
      </>
    );
  }
}
